import * as d3 from 'd3';

const closure = mainApp => {
    mainApp.urbanRuralGraph = function(container) {
        var svg = container
            .append('svg')
            .attr('width', mainApp.params.width)
            .attr('height', mainApp.params.height)
            .attr('fill', 'white');

        var margin = { top: 150, right: 20, bottom: 125, left: 150 };
        var width = svg.attr('width') - margin.left - margin.right;
        var height = svg.attr('height') - margin.top - margin.bottom;

        var g = svg
            .append('g')
            .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

        var x = d3.scaleLinear().range([0, width]);
        var y = d3.scaleLinear().range([height, 0]);
        var z = d3.scaleOrdinal(['#002E5F', '#E70033']);

        var stack = d3.stack();

        var area = d3
            .area()
            .x(function(d) {
                return x(d.data.YEAR);
            })
            .y0(function(d) {
                return y(d[0]);
            })
            .y1(function(d) {
                return y(d[1]);
            })
            .curve(d3.curveNatural);

        var dataRaw = mainApp.urban;

        var dataAll = {
            World: dataRaw.map(function(d) {
                return {
                    YEAR: d.YEAR,
                    'World - Urban': d['World - Urban'],
                    'World - Rural': d['World - Rural']
                };
            }),
            'More developed': dataRaw.map(function(d) {
                return {
                    YEAR: d.YEAR,
                    'More developed - Urban': d['More developed - Urban'],
                    'More developed - Rural': d['More developed - Rural']
                };
            }),
            'Less developed': dataRaw.map(function(d) {
                return {
                    YEAR: d.YEAR,
                    'Less developed - Urban': d['Less developed - Urban'],
                    'Less developed - Rural': d['Less developed - Rural']
                };
            }),
            dummy: dataRaw.map(function(d) {
                return {
                    YEAR: d.YEAR,
                    'World - Urban': 1,
                    'World - Rural': 1
                };
            })
        };

        dataAll['World'].columns = ['YEAR', 'World - Rural', 'World - Urban'];
        dataAll['More developed'].columns = [
            'YEAR',
            'More developed - Rural',
            'More developed - Urban'
        ];
        dataAll['Less developed'].columns = [
            'YEAR',
            'Less developed - Rural',
            'Less developed - Urban'
        ];
        dataAll['dummy'].columns = ['YEAR', 'World - Rural', 'World - Urban'];

        var surpassLines = {
            World: 2006,
            'More developed': undefined,
            'Less developed': 2016,
            dummy: 1950
        };

        var data = dataAll['World'];

        var keys = data.columns.slice(1);
        stack.keys(keys);

        x.domain([1950, 2030]);

        y.domain([0, 10000000000]);

        var buildArea = function(type) {
            var data = dataAll[type];

            var keys = data.columns.slice(1);
            stack.keys(keys);

            g.selectAll('.layer').remove();
            g.selectAll('.surpass-line').remove();
            g.selectAll('.surpass-text').remove();

            var layer = g
                .selectAll('.layer')
                .data(stack(data))
                .enter()
                .insert('g', ':first-child')
                .attr('class', 'layer');

            layer
                .append('path')
                .attr('class', 'area')
                .style('fill', function(d) {
                    return z(d.key);
                })
                .attr('d', area);

            layer
                .filter(function(d) {
                    return d[d.length - 1][1] - d[d.length - 1][0] > 0.01;
                })
                .append('text')
                .attr('class', 'series-label text-header')
                .attr('x', width - 10)
                .attr('y', function(d) {
                    return y((d[d.length - 1][0] + d[d.length - 1][1]) / 2);
                })
                .attr('dy', '.35em')
                .style('font-size', '12px')
                .style('text-anchor', 'end')
                .text(function(d) {
                    if (d.key.indexOf('Urban') >= 0) {
                        return 'Rural';
                    } else {
                        return 'Urban';
                    }
                });

            if (type !== 'More developed') {
                g.append('line')
                    .attr('class', 'surpass-line')
                    .attr('x1', x(surpassLines[type]))
                    .attr('y1', y(0))
                    .attr('x2', x(surpassLines[type]))
                    .attr('y2', y(8500000000))
                    .style('stroke', 'darkgray')
                    .style('stroke-width', '2.5px')
                    .style('stroke-dasharray', '6 6');

                g.append('text')
                    .attr('class', 'surpass-text text-header')
                    .attr('x', x(surpassLines[type]))
                    .attr('y', y(8200000000))
                    .attr('dx', '-5px')
                    .attr('text-anchor', 'end')
                    .style('fill', 'black')
                    .style('font-size', '12px')
                    .style('font-weight', 'bold')
                    .text('Urban population surpasses rural');
            }
        };

        var updateArea = function(type) {
            var data = dataAll[type];

            var keys = data.columns.slice(1);
            stack.keys(keys);

            g.selectAll('.area')
                .data(stack(data))
                .transition()
                .duration(500)
                .style('fill', function(d) {
                    return z(d.key);
                })
                .attr('d', area);

            g.selectAll('.series-label')
                .data(stack(data))
                .transition()
                .duration(500)
                .attr('y', function(d) {
                    return y((d[d.length - 1][0] + d[d.length - 1][1]) / 2);
                });

            if (type !== 'More developed') {
                var hidden = g.select('.surpass-line').style('opacity') == 0;

                if (hidden) {
                    g.select('.surpass-line')
                        .attr('x1', x(surpassLines[type]))
                        .attr('y1', y(0))
                        .attr('x2', x(surpassLines[type]))
                        .attr('y2', y(8500000000))
                        .transition()
                        .duration(200)
                        .style('opacity', 1);

                    g.select('.surpass-text')
                        .attr('x', x(surpassLines[type]))
                        .attr('y', y(8200000000))
                        .transition()
                        .duration(200)
                        .style('opacity', 1);
                } else {
                    g.select('.surpass-line')
                        .transition()
                        .duration(500)
                        .attr('x1', x(surpassLines[type]))
                        .attr('y1', y(0))
                        .attr('x2', x(surpassLines[type]))
                        .attr('y2', y(8500000000));

                    g.select('.surpass-text')
                        .transition()
                        .duration(500)
                        .attr('x', x(surpassLines[type]))
                        .attr('y', y(8200000000));
                }
            } else {
                g.select('.surpass-line')
                    .transition()
                    .duration(200)
                    .style('opacity', 0);

                g.select('.surpass-text')
                    .transition()
                    .duration(200)
                    .style('opacity', 0);
            }
        };

        buildArea('dummy');
        updateArea('World');

        g.append('g')
            .attr('class', 'axis axis--x')
            .attr('transform', 'translate(0,' + height + ')')
            .call(d3.axisBottom(x).tickFormat(d3.format('.0f')));

        g.append('g')
            .attr('class', 'axis axis--y')
            .call(d3.axisLeft(y).tickFormat(d3.format('.1s')))
            .append('text')
            .attr('class', 'text-header')
            //.attr("transform", "rotate(-90)")
            .attr('transform', 'translate(' + 60 + ',' + -30 + ')')
            .attr('y', 6)
            .attr('dy', '0.71em')
            .attr('fill', '#000')
            .style('font-size', '14px')
            .style('font-weight', 'bold')
            .text('Population (billions)');

        g.selectAll('.tick text')
            .style('font-size', '14px')
            .style('font-weight', 'bold');

        g.selectAll('.axis--y .tick text').text(function(d) {
            return d / 1000000000;
        });

        // buttons
        var buttons = g
            .selectAll('.select-button')
            .data(['More developed', 'Less developed', 'World'])
            .enter()
            .append('g')
            .attr('class', '.select-button')
            .style('cursor', 'pointer')
            .on('click', function(d) {
                updateArea(d);

                buttons.selectAll('rect').style('fill-opacity', 0);
                d3.select(this)
                    .selectAll('rect')
                    .style('fill-opacity', 0.3);
            });

        buttons
            .append('rect')
            .attr('width', 110)
            .attr('height', 30)
            .attr('fill', 'black')
            .style('fill-opacity', function(d) {
                if (d === 'World') {
                    return 0.3;
                } else {
                    return 0;
                }
            })
            .attr('stroke', 'black')
            .attr('stroke-width', 2)
            .attr('transform', function(d, i) {
                return 'translate(' + (width / 2 - 210 + 130 * i) + ',' + 0 + ')';
            });

        buttons
            .append('text')
            .attr('class', 'text-header')
            .attr('fill', 'black')
            .attr('font-size', '12px')
            .attr('font-weight', 'bold')
            .style('text-anchor', 'middle')
            .style('text-align', 'center')
            .attr('transform', function(d, i) {
                return 'translate(' + (width / 2 - 210 + 130 * i + 55) + ',' + 20 + ')';
            })
            .text(function(d) {
                return d;
            });

        g.append('text')
            .attr('class', 'text-header')
            .attr('fill', 'black')
            .attr('font-size', '14px')
            .attr('font-weight', 'bold')
            .style('text-anchor', 'middle')
            .style('text-align', 'center')
            .attr('transform', function() {
                return 'translate(' + (width / 2 - 260) + ',' + 20 + ')';
            })
            .text('Select one:');
    };
};

export default closure;
